export default [
    {
        code: 'labourUnionBusinessReport',
        name: '工会业务报表',
        icon: 'el-icon-s-home',
        parentKey: '',
        selfFlg: 'labourUnionBusinessReport',
        children: [
            {
                code: 'reportQuery',
                name: '报表查询',
                parentKey: 'labourUnionBusinessReport',
                selfFlg: 'reportQuery'
            }
        ]
    }
];
